import { Controller } from "@hotwired/stimulus"

const POPUP_ID   = 'wx-tooltip-popup'
const GAP        = 10  // target ↔ popup 간격 (px)
const EDGE       = 8   // 뷰포트 최소 여백 (px)
const DELAY_HIDE = 80  // 빠른 mouseleave 오탐 방지 딜레이 (ms)

export default class extends Controller {
  connect() {
    this._popup = document.getElementById(POPUP_ID) || this._createPopup()
    this._hideTimer = null

    this._onEnter    = this._onEnter.bind(this)
    this._onLeave    = this._onLeave.bind(this)
    this._onFocusIn  = this._onFocusIn.bind(this)
    this._onFocusOut = this._onFocusOut.bind(this)

    // capture=true: 자식 요소의 mouseenter도 위임으로 잡기 위함
    this.element.addEventListener('mouseenter', this._onEnter,    true)
    this.element.addEventListener('mouseleave', this._onLeave,    true)
    this.element.addEventListener('focusin',    this._onFocusIn,  true)
    this.element.addEventListener('focusout',   this._onFocusOut, true)
  }

  disconnect() {
    this.element.removeEventListener('mouseenter', this._onEnter,    true)
    this.element.removeEventListener('mouseleave', this._onLeave,    true)
    this.element.removeEventListener('focusin',    this._onFocusIn,  true)
    this.element.removeEventListener('focusout',   this._onFocusOut, true)
    clearTimeout(this._hideTimer)
  }

  _onEnter(event) {
    const target = event.target.closest('[data-tooltip]')
    if (!target) return
    clearTimeout(this._hideTimer)
    this._showFor(target)
  }

  _onLeave(event) {
    const target = event.target.closest('[data-tooltip]')
    if (!target) return
    if (event.relatedTarget && target.contains(event.relatedTarget)) return
    this._scheduleHide()
  }

  _onFocusIn(event) {
    const target = event.target.closest('[data-tooltip]')
    if (!target) return
    clearTimeout(this._hideTimer)
    this._showFor(target)
  }

  _onFocusOut(event) {
    const target = event.target.closest('[data-tooltip]')
    if (!target) return
    this._scheduleHide()
  }

  _showFor(target) {
    const text = target.dataset.tooltip
    if (!text) return

    const popup = this._popup
    popup.textContent = text

    popup.style.left       = '-9999px'
    popup.style.top        = '-9999px'
    popup.style.visibility = 'hidden'
    popup.style.display    = 'block'
    popup.classList.remove('is-visible')

    this._position(target)

    popup.style.visibility = ''
    popup.style.display    = ''
    popup.classList.add('is-visible')
  }

  _scheduleHide() {
    this._hideTimer = setTimeout(() => {
      this._popup.classList.remove('is-visible')
    }, DELAY_HIDE)
  }

  _position(target) {
    const popup = this._popup
    const rect  = target.getBoundingClientRect()
    const vw    = window.innerWidth
    const vh    = window.innerHeight
    const pw    = popup.offsetWidth  || 260
    const ph    = popup.offsetHeight || 40

    let top
    if (rect.top >= ph + GAP + EDGE) {
      top = rect.top - ph - GAP
      popup.dataset.dir = 'up'
    } else if (vh - rect.bottom >= ph + GAP + EDGE) {
      top = rect.bottom + GAP
      popup.dataset.dir = 'down'
    } else {
      top = Math.max(EDGE, rect.top - ph - GAP)
      popup.dataset.dir = 'up'
    }

    let left = rect.left + rect.width / 2 - pw / 2
    left = Math.max(EDGE, Math.min(left, vw - pw - EDGE))

    popup.style.top  = `${top}px`
    popup.style.left = `${left}px`
  }

  _createPopup() {
    const el = document.createElement('div')
    el.id = POPUP_ID
    el.setAttribute('role', 'tooltip')
    document.body.appendChild(el)
    return el
  }
}
